import { render } from "./SsoEntryPage.vue?vue&type=template&id=5539f0ba&scoped=true"
import script from "./SsoEntryPage.vue?vue&type=script&lang=js"
export * from "./SsoEntryPage.vue?vue&type=script&lang=js"

import "./SsoEntryPage.vue?vue&type=style&index=0&id=5539f0ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5539f0ba"]])

export default __exports__